export const decodeJWTToken = (token) => {
    if (!token) return null;

    try {
        // Remove 'Bearer ' prefix if present
        const cleanToken = token.replace(/^Bearer\s+/, '');

        const parts = cleanToken.split('.');
        if (parts.length !== 3) return null;

        const payload = parts[1];

        // Convert from Base64URL to Base64
        const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');

        // Add padding
        const paddedBase64 = base64 + '='.repeat((4 - (base64.length % 4)) % 4);

        // Decode
        const decodedPayload = JSON.parse(atob(paddedBase64));

        return decodedPayload;
    } catch (error) {
        console.error('Error decoding JWT token:', error);
        return null;
    }
};
